import * as THREE from 'three'
import CustomShaderMaterial from 'three-custom-shader-material/vanilla'

import slicedVertexShader from '../shaders/sliced/vertex.glsl'
import slicedFragmentShader from '../shaders/sliced/fragment.glsl'

export default function createSliceMaterials({ uniforms, patchMap })
{
  const makeSlicedFrom = (baseMat) =>
  {
    // If the model uses non-standard materials, convert to something compatible
    // Most glb PBR materials are MeshStandardMaterial already, so usually fine.
    const baseMaterial =
      baseMat?.isMeshPhysicalMaterial || baseMat?.isMeshStandardMaterial
        ? baseMat
        : new THREE.MeshStandardMaterial({ color: baseMat?.color ?? '#ffffff' })

    const sliced = new CustomShaderMaterial({
      // CSM
      baseMaterial: baseMaterial,
      vertexShader: slicedVertexShader,
      fragmentShader: slicedFragmentShader,
      uniforms,
      patchMap,

      // Important for inside slice
      side: THREE.DoubleSide,
    })

    const slicedDepth = new CustomShaderMaterial({
      // CSM
      baseMaterial: THREE.MeshDepthMaterial,
      vertexShader: slicedVertexShader,
      fragmentShader: slicedFragmentShader,
      uniforms,
      patchMap,

      // MeshDepthMaterial
      depthPacking: THREE.RGBADepthPacking
    })

    return { sliced, slicedDepth }
  }

  return { makeSlicedFrom }
}
